import axios from "utils/axiosConfig";
import { urlService } from "infra/envs";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";

export default function useClaimCandidate() {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(null);

    const claimCandidate =  async (candidateId) => {
        if(!candidateId) return;
        setIsLoading(true);
        try {
            await axios.post(`${urlService.CANDIDATE_CLAIM_PATH}/${candidateId}`);
            setIsSuccess(true);
            enqueueSnackbar("Candidate claimed successfully.", {
                variant: "success",
                autoHideDuration: 2000
            });
        } catch (error) {
            console.error("Error claiming candidate:", error);
            setIsSuccess(false);
            enqueueSnackbar(
                "Error claiming candidate. Please try again.", {
                    variant: "error",
                    autoHideDuration: 2000
                })
        } finally {
            setIsLoading(false);
        }
    };

    return {
        claimCandidate,
        isLoading,
        isSuccess,
    }; 
}